module.exports = __webpack_public_path__ + "media/vue/assets/images/account/beauty_pass/hero_mobile-3e5a544238359e8cc2136be13db13e69.jpg";